function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import MUIDialogContent from '@mui/material/DialogContent';
export const DialogContent = props => {
  // const classes = useStyles();
  const className = null; // (props.disableTypography!=true) ? classes.defaultTypograpy : null;
  return /*#__PURE__*/React.createElement(MUIDialogContent, _extends({}, props, {
    className: className
  }));
};
export default DialogContent;